import { LOCALES } from '@marketplace/i18n';

import { registrationFormI18n } from './registration-form';
import { registrationCompletionI18n } from './completion';

export const registrationModalI18n = {
  [LOCALES.ENG]: {
    registrationModalFeature_submitButton: 'Submit',
    registrationModalFeature_prevButton: 'Previous',
    registrationModalFeature_nextButton: 'Next',
    registrationModalFeature_rejectButton: 'Cancel',
    registrationModalFeature_modalTitle: 'Create your account {stepCount} of {stepsCount} steps',
    registrationModalFeature_account: 'Already have an account? {login}',
    registrationModalFeature_login: 'Login',
    ...registrationCompletionI18n[LOCALES.ENG],
    ...registrationFormI18n[LOCALES.ENG],
    ...registrationFormI18n[LOCALES.ENG],
    ...registrationFormI18n[LOCALES.ENG],
  },
};
